import type {DateValue} from '../types';

import moment from 'moment-jalaali';

/** Jalali `jYYYY-jMM-jDD` or `YYYY-M-D` → Gregorian `YYYY-MM-DD` */
export function convertJalaliToGregorian(dateString: string): string {
  const jalaliDate = moment(dateString, ['jYYYY-jMM-jDD', 'jYYYY-jM-jD']);
  return jalaliDate.clone().locale('en').format('YYYY-MM-DD');
}

export function convertToJalali(gregorianDate: string): string {
  if (!gregorianDate) return '';
  return moment(gregorianDate, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('jYYYY-jMM-jDD');
}

/** Weekday index 0–6 for Jalali calendar grid (شنبه = 0) */
export function getJalaliFirstWeekday(jYear: number, jMonth: number): number {
  const firstDayOfMonth = moment(`${jYear}-${jMonth + 1}-1`, 'jYYYY-jM-jD');
  const gregorianDay = firstDayOfMonth.toDate().getDay();
  return (gregorianDay + 1) % 7;
}

export function toGregorianFromJalaliMoment(m: moment.Moment): DateValue {
  return convertJalaliToGregorian(m.format('jYYYY-jMM-jDD'));
}
